import { Button } from "@/shared/ui/button.tsx";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose
} from "@/shared/ui/dialog.tsx"
import { CheckCircle, Undo2 } from "lucide-react";
//import { useSchedulePost } from "../api/suggested-api";

type ConfirmScheduleDialogProps = {
  trigger: JSX.Element,
  post_id: number,
  eventIndex: number,
  closeSideBar?: () => void,
  onSchedule: (id: number) => void
}

const ConfirmScheduleDialog = ({ trigger, closeSideBar }: ConfirmScheduleDialogProps) => {

 // const { schedulePost } = useSchedulePost(onSchedule, eventIndex)

  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="w-full text-center font-montserrat">Schedule post</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <p>Are you sure you want to post it?</p>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button type="button" className="flex items-center gap-2 bg-amber-500">Make changes <Undo2 /></Button>
          </DialogClose>
          <DialogClose asChild>
            <Button
              type="button"
              onClick={() => {
               // schedulePost(post_id)
                if (closeSideBar) {
                  closeSideBar()
                }
              }}
              className="flex items-center gap-2">
              Yes Schedule <CheckCircle />

            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmScheduleDialog;
